import { getMangoApiClient } from '~/atoms/MangoApi'

import { createMusicOnHoldApi } from '@mangovoice/music-on-hold-ui'

export const musicOnHoldApi = createMusicOnHoldApi(
  getMangoApiClient().musicOnHold,
)
